import apiClient from '../client';
import ENDPOINTS from '../endpoints';

/* One submission is one household: a student, the parent who filled it in, and
   optionally a second parent. The table lists parents, so a form with both
   becomes two rows sharing the student and the group-chat answer. */
function toRows(form) {
  const shared = {
    formId: form?._id || form?.id || '',
    student: form?.studentName || '',
    joinGroupChat: form?.joinGroupChat === true,
    /* a full ISO timestamp; fmtDate appends T00:00:00, so trim to yyyy-mm-dd */
    submittedAt: String(form?.createdAt || '').slice(0, 10),
    /* blank when someone filled the form in without an account */
    userId: form?.userId || '',
  };
  const rows = [
    {
      ...shared,
      role: 'primary',
      name: form?.primaryParentName || '',
      email: form?.primaryEmail || '',
      phone: form?.primaryPhone || '',
    },
  ];
  /* the second parent is optional and arrives as empty strings when skipped */
  if (form?.secondaryParentName || form?.secondaryEmail) {
    rows.push({
      ...shared,
      role: 'secondary',
      name: form.secondaryParentName || '',
      email: form.secondaryEmail || '',
      phone: form.secondaryPhone || '',
    });
  }
  return rows;
}

const consentService = {
  /* Submissions for one class, newest first. Paginated server-side over forms,
     not over the parent rows they expand into, so `total` counts responses
     while `rows` can be longer. joinGroupChatCount covers the whole network and
     ignores the filters. */
  list: async (networkId, { page = 1, limit = 10, search = '', joinGroupChat, status } = {}) => {
    const res = await apiClient.get(ENDPOINTS.ROOM_PARENT_ADMIN.CONSENT_FORMS_BY_NETWORK(networkId), {
      params: {
        page,
        limit,
        search,
        ...(joinGroupChat === undefined ? {} : { joinGroupChat }),
        ...(status ? { status } : {}),
      },
    });
    const data = res?.data ?? res;
    const forms = data?.forms || (Array.isArray(data) ? data : []);
    const total = Number(data?.totalCount ?? data?.total ?? forms.length);
    return {
      rows: forms.flatMap(toRows),
      total,
      totalPages: Number(data?.totalPages ?? Math.max(1, Math.ceil(total / limit))),
      joinGroupChatCount: Number(data?.joinGroupChatCount ?? 0),
    };
  },
};

export default consentService;
